<template>
  <v-card>
    <v-card-title class="CdkFilterForm-title">
      <slot name="title"></slot>
    </v-card-title>
    <v-card-text>
      <slot></slot>
      <v-form @submit.stop.prevent="$emit('saveNewFilter')">
        <v-text-field
          v-model="internalValue"
          label="Name"
          :placeholder="$t('no_title')"
          required
          :rules="[
            nonEmpty,
            ...(isNewFilter ? [nonDuplicateName] : []),
            ...mappedValidationRules
          ]"
          autofocus
        ></v-text-field>
        <slot name="color-picker" />
      </v-form>
      <slot name="notifications" />
    </v-card-text>
    <v-divider v-if="color && internalValue" />
    <v-card-actions class="py-3"> <slot name="actions"></slot> </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      // NB: The same message is shown for non-empty and duplicate names.
      validationMessage: "Vergeben Sie einen neuen, eindeutigen Namen."
    };
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    owner: {
      type: String,
      default: ""
    },
    filterRules: {
      type: Array,
      default: () => []
    },
    tokens: {
      type: Array,
      default: () => []
    },
    isVisible: {
      type: Boolean,
      default: true
    },
    // Array of validation booleans
    validationRules: {
      type: Array,
      default: () => []
    },
    filterNames: {
      type: Array,
      default: () => []
    },
    isNewFilter: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    // Mapped passed validation rules as validation functions
    mappedValidationRules() {
      return this.validationRules.map(rule => () =>
        rule || this.validationMessage
      );
    },

    nonDuplicateName() {
      return !this.filterNames.includes(this.value) || this.validationMessage;
    }
  },
  methods: {
    ...mapActions("filters", ["undo"]),
    handleSaveClick({ color, name }) {
      this.$emit("saveClick", {
        color,
        name
      });
    },

    // Validation rules
    nonEmpty() {
      return this.value.length > 0 || this.validationMessage;
    }
  }
};
</script>
<style postcss>
.CdkFilterForm-title {
  background-color: #f5f5f5;
  border-bottom: 1px solid #d8d8d8;
}
</style>
